import { Property } from "./property";

export class ClonableObject
{
    clone()
    {
        return Object.assign({}, this);
    }
}
